import { ReactNode, useEffect, useState } from 'react';
import { LoadingIndicator } from 'components';
import { initI18n, fallbackLanguage } from '../i18n';

interface DetectedLanguageProviderProps {
    children: ReactNode;
}

// used when we can't get language from API, then we use fallback language
export const InitialLanguageProvider = ({ children }: DetectedLanguageProviderProps) => {
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        // we can't get language from API, so we use fallback language
        initI18n(fallbackLanguage, () => {
            // WCAG 3.1.1 Language of Page - Ensure HTML lang attribute matches content
            const langCode = fallbackLanguage.split('-')[0];
            document.documentElement.lang = langCode;
            setIsReady(true);
        });
    }, []);

    if (!isReady) {
        return (
            <div className='h-screen'>
                <LoadingIndicator center />
            </div>
        );
    }

    return <>{children}</>;
};
